import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5628%3A759
 *
 * @param {SvgIconProps} props - svg props
 */
export const PauseCircleOutlineIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM12 20.8C7.149 20.8 3.2 16.851 3.2 12C3.2 7.149 7.149 3.2 12 3.2C16.851 3.2 20.8 7.149 20.8 12C20.8 16.851 16.851 20.8 12 20.8Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M9.25 16H10.75C11.0261 16 11.25 15.7761 11.25 15.5V8.5C11.25 8.22386 11.0261 8 10.75 8H9.25C8.97386 8 8.75 8.22386 8.75 8.5V15.5C8.75 15.7761 8.97386 16 9.25 16ZM13.25 16H14.75C15.0261 16 15.25 15.7761 15.25 15.5V8.5C15.25 8.22386 15.0261 8 14.75 8H13.25C12.9739 8 12.75 8.22386 12.75 8.5V15.5C12.75 15.7761 12.9739 16 13.25 16Z' fill={color}/>
        </SvgIcon>
    )
}

export default PauseCircleOutlineIcon
